import React from 'react';
import { Link } from 'react-router-dom';

export default function PaymentCancelled() {
  return (
    <div style={{ 
      maxWidth: '600px', 
      margin: '50px auto', 
      padding: '40px', 
      textAlign: 'center',
      backgroundColor: '#f8f9fa',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    }}>
      <div style={{ fontSize: '64px', marginBottom: '20px' }}>❌</div>
      <h1 style={{ color: '#dc3545', marginBottom: '20px' }}>Payment Cancelled</h1>
      <p style={{ fontSize: '18px', marginBottom: '30px', color: '#6c757d' }}>
        Your payment was cancelled. No charges were made to your account.
      </p>
      
      <div style={{ 
        backgroundColor: '#fff3cd', 
        padding: '20px', 
        borderRadius: '8px', 
        marginBottom: '30px',
        border: '1px solid #ffc107'
      }}>
        <h3 style={{ marginBottom: '10px', color: '#856404' }}>What Happened?</h3>
        <p style={{ color: '#856404' }}>
          You can still enjoy the basic features of GradedWash for free. 
          Upgrade anytime to unlock premium features like messaging, local meets, and travel groups.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ marginBottom: '15px' }}>Free Features Available</h3>
        <ul style={{ textAlign: 'left', display: 'inline-block' }}>
          <li>Browse user profiles</li>
          <li>Take personality quiz</li>
          <li>View blog articles</li>
          <li>Basic personality matching</li>
        </ul>
      </div>

      <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
        <Link to="/feed" style={{
          padding: '12px 24px',
          backgroundColor: '#007bff',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '6px',
          fontWeight: 'bold'
        }}>
          Continue Browsing
        </Link>
        <Link to="/profile" style={{
          padding: '12px 24px',
          backgroundColor: '#6c757d',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '6px',
          fontWeight: 'bold'
        }}>
          View Profile
        </Link>
      </div>
    </div>
  );
} 